import { faqData } from '@/mocks/comics';

export default function FAQSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            id="faq-heading"
            className="font-heading font-bold text-2xl md:text-3xl text-foreground-900"
          >
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            关于韩国漫画网，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="font-medium text-sm text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqData.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        })}
      </script>
    </section>
  );
}